import Util from './util';
jQuery(document).ready(function ($) {
    $(".wm-counter").each(function () {
        const $text = $(this).find(".wm-counter__counter");
        const targetValue = parseFloat($(this).data("target-value"));
        const ofValue = parseFloat($(this).data("of-value"));
        const suffix = $(this).data("suffix");
        const isInteger = targetValue % 1 === 0;
        function animate() {
            function buildText(value) {
                let val = isInteger ? Math.round(value) : value.toFixed(1);
                return val.toString() + (suffix || '');
            }
            const animationSpeed = 2000;
            $({ value: 0.0 }).animate({
                value: targetValue
            }, {
                duration: animationSpeed,
                step: function (value) {
                    $text.text(buildText(value));
                },
                complete: function () {
                    $text.text(buildText(targetValue));
                }
            });
        }
        const checkBounds = () => {
            if (Util.isInView($(this))) {
                $(window).off("scroll", checkBounds);
                animate();
            }
        };
        if (Util.isInView($(this)))
            animate();
        else
            $(window).on("scroll", checkBounds);
    });
});
